export default "__VITE_ASSET__QdlSAsu4__"